import { defaultMemoize } from 'reselect';
import * as _ from 'underscore';

import { IUserInfo } from '../ts/models/IUserInfo';
import { queryStringSelector } from './selectors/SiteUrlsSelectors';

// TODO: This should be moved to @tableau/shared-urls.

/*
 * Constructs urls for server pages, given a query string.
 *
 * e.g.
 *
 *   const serverUrls = ServerUrls.getInstance();
 *   serverUrls.sitesUrl();    // returns '/?foo=bar#/server/sites'
 */
export class ServerUrls {

  private static memoizedCreateInstance = defaultMemoize((queryString: string) => new ServerUrls(queryString));

  public static getInstance(): ServerUrls {
    const queryString = queryStringSelector();
    return ServerUrls.memoizedCreateInstance(queryString);
  }

  public static instanceWithCustomQueryStringForTesting(queryString: string) {
    return new ServerUrls(queryString);
  }

  private readonly prefix: string;

  // TODO: The logic in this  is a subset of that in SiteUrls; it should be deduped.
  private constructor(queryString: string) {

    // Sanitize inputs and calculate prefix

    queryString = _.isString(queryString) ? queryString : '';

    // Insert a '?' if necessary
    if (queryString && queryString.length > 0 && queryString[0] !== '?') {
      queryString = '?' + queryString;
    }

    this.prefix = '/' + queryString + '#';
  }

  public serverUrl() {
    return this.prefix + '/server';
  }

  public sitesUrl() {
    return this.serverUrl() + '/sites';
  }

  public usersUrl() {
    return this.serverUrl() + '/users';
  }

  public schedulesUrl(): string {
    return this.serverUrl() + '/schedules';
  }

  public scheduleUrl(scheduleId: string): string {
    return this.schedulesUrl() + '/' + scheduleId;
  }

  public scheduleExtractRefreshesUrl(scheduleId: string): string {
    return this.scheduleUrl(scheduleId) + '/extractRefreshes';
  }

  public scheduleFlowsUrl(scheduleId: string): string {
    return this.scheduleUrl(scheduleId) + '/flows';
  }

  public scheduleSubscriptionsUrl(scheduleId: string): string {
    return this.scheduleUrl(scheduleId) + '/subscriptions';
  }

  public jobsUrl() {
    return this.serverUrl() + '/jobs';
  }

  public tasksUrl() {
    return this.serverUrl() + '/tasks';
  }

  public statusUrl() {
    return this.serverUrl() + '/status';
  }

  public settingsUrl() {
    return this.serverUrl() + '/settings';
  }

  // TODO: This reference to IUserInfo should be removed.
  public userSettingsUrl(user: IUserInfo) {
    return this.serverUrl() + '/user/' + encodeURIComponent(user.domainName) + '/' + encodeURIComponent(user.username) + '/settings';
  }

}
